/* eslint-disable */
export default {
  noResultFoundFor: '未找到对应结果：',
  foundFromServerHint: '输入关键字并按 Enter，在 {appName} 中进行搜索',
  notResultFoundFromServer: '找不到结果',
  loading: '正在加载...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
